exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-e23d417a],select[data-v-e23d417a]{border-style:solid}.has-color-picker-lr button[data-v-e23d417a]{width:150px!important}#preview_iframe[data-v-e23d417a]{width:100%;height:650px;border:1px solid #ccc}.v-slider--horizontal .v-slider__track-container[data-v-e23d417a]{height:7px}.v-input--radio-group.v-input--radio-group--row .v-radio[data-v-e23d417a]{width:100%!important}.v-input--selection-controls .v-input__slot>.v-label[data-v-e23d417a],.v-input--selection-controls .v-radio>.v-label[data-v-e23d417a]{padding-top:7px}div.v-slider__thumb-container span[data-v-e23d417a]{font-size:15px!important}", ""]);

// exports
